/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestTheGraphEpochManager extends Contract<ITestTheGraphEpochManager> {
  currentEpoch: Call<() => BigNumber, ITestTheGraphEpochManager>
  'currentEpoch()': Call<() => BigNumber, ITestTheGraphEpochManager>
  runEpoch: Send<() => void, ITestTheGraphEpochManager>
  'runEpoch()': Send<() => void, ITestTheGraphEpochManager>
  setEpochLength: Send<(_epochLength: BigNumberish) => void, ITestTheGraphEpochManager>
  'setEpochLength(uint256)': Send<(_epochLength: BigNumberish) => void, ITestTheGraphEpochManager>
}

let ITestTheGraphEpochManagerBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestTheGraphEpochManagerBytecode = '0x';
}

// prettier-ignore
export const ITestTheGraphEpochManager = contract<ITestTheGraphEpochManager>(ITestTheGraphEpochManagerBytecode)`
  function currentEpoch() view returns (uint256 epoch_)
  function runEpoch()
  function setEpochLength(uint256 _epochLength)
`;